import { Component, DestroyRef, OnInit } from '@angular/core';
import { API } from 'src/app/services/api/api';
import { ErrorService } from 'src/app/services/error.service';
import { ToasterService, ToastType } from 'src/app/services/toaster/toaster.service';
import { UtilService } from 'src/app/services/util.service';
import { finalize, take } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'sp-page-admin-overview',
  templateUrl: './admin-overview.component.html',
  styleUrls: ['./admin-overview.component.scss'],
  standalone: false,
})
export class AdminOverviewComponent implements OnInit {
  loading: boolean;
  locked: boolean;
  cacheLock: boolean;

  constructor(
    private api: API,
    public util: UtilService,
    public errorHandler: ErrorService,
    public toastHandler: ToasterService,
    private destroyRef: DestroyRef
  ) {
    this.loading = true;
    this.locked = true;
    this.cacheLock = true;
  }

  ngOnInit(): void {
    this.api
      ._admin_AdminEndpoints_uptime()
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        take(1),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe({
        next: (uptime: number) => {
          if (uptime) {
            this.locked = false;
            this.cacheLock = false;
          }
        },
        error: () => {},
      });
  }

  deletePlaylistCache() {
    if (!this.cacheLock) {
      this.cacheLock = true;
      this.api
        ._admin_AdminEndpoints_deletePlaylistCache()
        .pipe(
          takeUntilDestroyed(this.destroyRef),
          take(1),
          finalize(() => {
            this.cacheLock = false;
          })
        )
        .subscribe({
          next: () => {
            this.toastHandler.toast(ToastType.SUCCESS, 'Deleting playlist cache successful.');
          },
          error: error => {
            this.toastHandler.toast(ToastType.DANGER, error.message);
          },
        });
    }
  }
}
